import React, { memo } from 'react';

import { FormattedMessage } from 'react-intl';

import { messages } from 'ui-components/components/dimension-input/dimension-number-input/messages';

import { DimensionType, DimensionTypePropType } from '../../../../enums/dimension-type';

export const DimensionUnitLabel = memo(({ dimensionType }) => {
  if (dimensionType === DimensionType.Length) {
    return <FormattedMessage {...messages.lengthAbbreviation} />;
  }
  if (dimensionType === DimensionType.Width) {
    return <FormattedMessage {...messages.widthAbbreviation} />;
  }
  if (dimensionType === DimensionType.Height) {
    return <FormattedMessage {...messages.heightAbbreviation} />;
  }
});

DimensionUnitLabel.propTypes = {
  dimensionType: DimensionTypePropType.isRequired,
};
